/* eslint-disable react/prop-types */
import React from "react";
import cs from "classnames";
import classes from "./GoldenInput.module.scss";

const GoldenInput = ({ placeholder, value, onChange, type = "text", className, ...props }) => (
  <input
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    className={cs(classes.input, className)}
    {...props}
  />
);

export default GoldenInput;
